<template>
    <DropDownButton
        :classes-prop="`c-user-info ${
            isDropDownActive ? 'router-link-exact-active' : ''
        } ${inBurgerMenu ? 'c-user-info--burger' : ''}`"
        :force-open="inBurgerMenu"
        btn-classes-prop="c-header__link"
        :is-header-dropdown="!inBurgerMenu"
    >
        <template #title>
            <img
                v-if="hasAmbassadorRewardClaimed"
                class="c-user-info--ambassador-reward"
                :src="iconAmbassador"
                alt="Ambassador"
            />
            <div v-if="$hasSchoolPremiumOrTrial" class="premium-nickname">
                <img
                    src="/images/teacher/teacher-premium/premium-crown.svg"
                    alt="crown"
                />
                <span>{{ user.firstName }} {{ user.lastName }}</span>
            </div>
            <span v-else>{{ user.firstName }} {{ user.lastName }}</span>
        </template>
        <!--todo: this component is no longer used in student's UI, consider cleanup-->
        <template #items>
            <ul>
                <li v-if="!inBurgerMenu && !shouldSeeClasses">
                    <router-link :to="{ name: 'teacher.classes' }">
                        {{ $t('classes.students') }}
                    </router-link>
                </li>
                <li
                    v-if="isStudent"
                    :class="{
                        'c-header__link--student': isStudent,
                    }"
                >
                    <router-link
                        :to="{
                            name: 'user-profile.public.with-player-name',
                            params: {
                                userPlayerName: user.playerName,
                                userId: user.userId,
                            },
                        }"
                    >
                        {{ $t('auth.profile.title') }}
                    </router-link>
                </li>
                <li
                    v-if="isStudent && !inBurgerMenu"
                    :class="{
                        'c-header__link--student': isStudent,
                    }"
                >
                    <router-link
                        :to="{
                            name: 'host.reports',
                        }"
                    >
                        {{ $t('reports.myGameReports') }}
                    </router-link>
                </li>
                <li
                    v-if="isTeacher"
                    :class="{
                        'c-header__link--teacher': inBurgerMenu,
                    }"
                >
                    <router-link :to="{ name: 'host' }">
                        Try new teacher's UI
                    </router-link>
                </li>
                <li
                    :class="{
                        'c-header__link--student': isStudent,
                        'c-header__link--teacher': !isStudent && inBurgerMenu,
                    }"
                >
                    <router-link
                        :to="{
                            name: 'user-profile',
                        }"
                    >
                        Settings & Profile Info
                    </router-link>
                </li>
                <li
                    :class="{
                        'c-header__link--student': isStudent,
                        'c-header__link--teacher': !isStudent && inBurgerMenu,
                    }"
                >
                    <a
                        v-if="isTeacher"
                        :href="fbGroupLink"
                        target="_blank"
                        rel="noopener"
                    >
                        {{ $t('header.joinCommunity') }}
                    </a>
                    <a
                        v-else-if="isParent"
                        href="https://www.facebook.com/99math/"
                        target="_blank"
                        rel="noopener"
                    >
                        {{ $t('header.joinCommunity') }}
                    </a>
                </li>
                <li v-if="isStudent" class="c-header__link--student">
                    <router-link
                        :to="{
                            name: 'user-profile.share',
                        }"
                    >
                        {{ $t('general.inviteFriends') }}
                    </router-link>
                </li>
                <StudentJoinClassMenuItem />
                <li
                    :class="{
                        'c-header__link--teacher': isTeacher && inBurgerMenu,
                    }"
                >
                    <a
                        @click.prevent="
                            $emitter.emit('openCustomerSupportModal')
                        "
                    >
                        Support
                    </a>
                </li>
                <li
                    :class="{
                        'c-header__link--student': isStudent,
                        'c-header__link--teacher': !isStudent && inBurgerMenu,
                    }"
                >
                    <a @click.prevent="logOut">
                        {{ $t('auth.logOut') }}
                    </a>
                </li>
            </ul>
        </template>
    </DropDownButton>
</template>
<script>
import iconAmbassador from '@/assets/ambassador-badge.svg';
import { mapActions, mapGetters } from 'vuex';
import DropDownButton from '@/core/ui/_legacy/DropDownButton.vue';
import {
    isTeacher,
    isParent,
    isStudent,
} from '@/flows/Authentication/helpers/AuthHelpers.js';
import { getFbGroupLink } from '@/core/helpers/utils.js';
import StudentJoinClassMenuItem from '@/core/widgets/MathHeader/components/StudentJoinClassMenuItem.vue';

export default {
    components: { DropDownButton, StudentJoinClassMenuItem },
    props: {
        inBurgerMenu: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isDropDownActive: false,
            myReferrals: [],
            iconAmbassador,
        };
    },
    computed: {
        ...mapGetters({
            user: 'user',
            reports: 'getReports',
            classList: 'getClassList',
            isUserFromUSA: 'isUserFromUSA',
            currentLanguage: 'getCurrentLanguage',
            liveGamesWithStudentsPlayed: 'getLiveGamesMin4PlayersPlayed',
        }),
        games() {
            return this.reports.filter((game) => !game.demo) || [];
        },
        isTeacher() {
            return isTeacher(this.user);
        },
        isParent() {
            return isParent(this.user);
        },
        isStudent() {
            return isStudent(this.user);
        },
        hasAmbassadorRewardClaimed() {
            return (
                this.isUserFromUSA &&
                this.myReferrals.length >= 10 &&
                this.user.latestReferralInviteStatus &&
                (this.user.latestReferralInviteStatus || {})
                    .donePreviousInviteGoal
            );
        },
        fbGroupLink() {
            return getFbGroupLink(this.currentLanguage);
        },
        shouldSeeClasses() {
            if (!this.isTeacher) {
                return false;
            }

            if (!this.isUserFromUSA) {
                return true;
            }

            return !!(
                this.isUserFromUSA &&
                this.classList &&
                this.classList.length > 0
            );
        },
    },
    watch: {
        $route(next) {
            this.checkIfActive(next.path);
        },
    },
    async mounted() {
        this.checkIfActive(this.$router.currentRoute.path);

        this.myReferrals = await this.getMyReferrals();
    },
    methods: {
        ...mapActions(['removeUserData', 'resetStoreState', 'getMyReferrals']),
        async logOut() {
            await this.$store.dispatch('generateGuestJwt', null, {
                root: true,
            });

            this.removeUserData();

            this.resetStoreState();

            if (this.$router.name !== 'home') {
                this.$router.push('/');
            }
        },
        checkIfActive(path) {
            this.isDropDownActive = path === '/profile';
        },
    },
};
</script>
<style lang="scss">
.c-user-info {
    display: flex;
    min-width: 180px;
    height: 100%;
    justify-content: flex-start;

    &::after {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        background-color: #f08a4f;
        bottom: 0;
        height: 4px;
        opacity: 0;
        transition: all 0.2s ease-in-out;
        pointer-events: none;
    }

    &:hover {
        &::after {
            opacity: 1;
        }
    }

    > button {
        @extend .c-header__link;
        opacity: 1;
        background: transparent;
        border: 0;
        cursor: pointer;
    }

    .c-dropdown-btn--dropdown {
        background-color: $quinary-theme-color;
        min-width: 270px;

        a:hover {
            background-color: $quaternary-theme-color;
        }
    }

    &--burger {
        opacity: 1;
        height: auto;

        .c-header__link:hover::after,
        &:hover::after {
            opacity: 0;
        }
    }
}

.c-user-info--ambassador-reward {
    margin-top: 8px;
}
.premium-nickname {
    display: flex;
    align-items: center;
    gap: 7px;

    span {
        color: #ffb743;
        font-weight: 600;
    }
}
</style>
